// extracted by mini-css-extract-plugin
export default {"mainFooterSocials":"MainFooterSocials_mainFooterSocials__4OS0C","socialIcon":"MainFooterSocials_socialIcon__ds09J"};